import React from 'react';
import { Input, Button, CheckboxTable, Textarea } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Socket } from 'utils';
import { ChatService } from 'services';
import { connect } from 'react-redux';

interface Props extends RootState {
  onClose?: any;
}

class ModalCreate extends React.Component<Props> {
  state = {
    form: {
      message: '',
    },
  };

  submit = async (e: any) => {
    e.preventDefault();

    const res: any = await ChatService.save({
      sender_id: this.props.user?.id,
      ...this.state.form,
    });

    if (res.waiting_accept) {
      return Globals.confirm(
        'Por favor, espere que un abogado acepte su solicitud, se le enviará una notificación cuando se acepte.',
        async () => {
          this.props.onClose(res.chat?.id);
        },
      );
    }

    this.props.onClose(res.chat?.id);
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  render() {
    return (
      <form id='modal-create-chat' onSubmit={this.submit}>
        <Textarea
          rows={6}
          value={this.state.form.message}
          placeholder='Mensaje'
          name='message'
          onChange={(e: any) => this.change(e)}
        />
        <div className='text-center'>
          <Button type='submit'>Enviar</Button>
        </div>
      </form>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(ModalCreate);
